import { Box, Button, Grid2, MenuItem, Modal, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import { useEffect, useState } from "react";
import config from "../../config/config";
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius:'8px'
};

const ChatSuggestion = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows,setRows] = useState([]);
    const [userTypeFilter, setUserTypeFilter] = useState('1'); 
    const [openAddModal, setOpenAddModal] = useState(false);
    const [editing, setEditing] = useState(false);
    const [suggestion, setSuggestion] = useState('');
    const [active, setActive] = useState(false);
    const [adminFilter, setAdminFilter] = useState(false);
    const [isAdmin, setIsAdmin] = useState(null);
    const [suggestionId, setSuggestionId] = useState('');
    const navigate = useNavigate();
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const fetchChatSuggestionsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/fetch_chat_suggestions';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                user_type: userTypeFilter,
                timestamp: timestamp
            };
            if(isAdmin!=null){
            body.is_admin = isAdmin;
        }
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
                setEditing(false);
                setOpenAddModal(false);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
        
    useEffect(() => {
        fetchChatSuggestionsData();
    }, [userTypeFilter, adminFilter]);

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setEditing(false);
        setSuggestion('');
        setActive('1');
        setSuggestionId('');
    }

    const handleViewDetails = (row) => {
        setOpenAddModal(true);
        setEditing(true);
        setSuggestion(row.suggestion);
        setActive(row.is_active);
        setSuggestionId(row.suggestion_id);
    }
    const handleClose = () => {
        setOpenAddModal(false);
        setEditing(false);
    }

    const saveCategory = async() => {
        const token = localStorage.getItem('token');
        const params = {
            token: token,
            user_type: userTypeFilter,
            suggestion: suggestion,
            is_active: (active==true || active==1) ? 1 : 0
        }
        if(isAdmin!=null){
            params.is_admin = isAdmin;
        }
        if(suggestionId!=''){
            params.suggestion_id = suggestionId;
        }
        try {
            const url = operationsUrl + '/panel/add_update_chat_suggestions';
            const response = await makePostRequestToUrl(url,params);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddModal(false);
                setEditing(false);
                fetchChatSuggestionsData();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    return (
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Chat Suggestions
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '3%' }}>
                <Grid2 item>
                    <Select value={userTypeFilter} 
                        onChange={(e) => setUserTypeFilter(e.target.value)} displayEmpty
                        style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: userTypeFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select User Type</MenuItem>
                        <MenuItem value="1">Customer</MenuItem>
                        <MenuItem value="2">Driver</MenuItem>
                    </Select>
                </Grid2>

                <Grid2 item sx={{display:'flex', alignItems:'center', border:'1px solid #D1D5DB', borderRadius:'8px', padding:'2px 4px', backgroundColor:'#f9f9f9'}}>
                    <Typography>Admin</Typography>
                    <Switch 
                        checked={adminFilter} 
                        onChange={(e) => {
                            setAdminFilter(e.target.checked)
                            if(e.target.checked){
                                setIsAdmin(1)
                            }else{
                                setIsAdmin(null)
                            }
                        }} 
                        inputProps={{ 'aria-label': 'controlled' }} 
                    />
                </Grid2>

                <Grid2 item>
                    <Button variant="contained" 
                    onClick={handleOpenAddModal} 
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: '#000000',textTransform: 'none'}}>
                        Add Chat
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Suggestion</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '10%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            return(
                                <TableRow key={row.fleet_id}>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.suggestion_id}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.suggestion}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.is_active === 1 ? '#0DBA78' : '#D14545', fontWeight:'500' }}>{row.is_active==1 ? 'Active' : 'Inactive'}</Typography></TableCell>
                                <TableCell align="center">
                                    <Button
                                        variant="contained"
                                        onClick={() => handleViewDetails(row)}
                                        sx={{
                                            backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                            borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                            '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                            '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                        }}>
                                        
                                        <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                            <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                        </svg>
                                    </Button>
                                </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Modal open={openAddModal} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {editing ? 'Edit Suggestion' : 'Add Suggestion'}
                    </Typography>
                    <hr/>
                    <Grid2 id="modal-modal-description" sx={{ mt: 2 }}>
                        <Grid2 item container size={12} sx={{ marginTop:'6%'}}>
                            <Grid2 item size={4}>
                                <Typography>Suggestion</Typography>
                            </Grid2>
                            <Grid2 item size={1}><Typography>:</Typography></Grid2>
                            <Grid2 item size={7}>
                                <TextField size="small"
                                    value={suggestion}
                                    onChange={(e) => setSuggestion(e.target.value)}
                                    sx={{ width: '300px', height:'40px', marginLeft:'4%' }}
                                />
                            </Grid2>
                        </Grid2>

                        {editing && 
                            <Grid2 item container size={12} sx={{ marginTop:'6%'}}>
                                <Grid2 item size={4}>
                                    <Typography sx={{marginTop:'1%'}}>Active</Typography>
                                </Grid2>
                                <Grid2 item size={1}><Typography sx={{marginLeft:'4%', marginTop:'6%'}}>:</Typography></Grid2>
                                <Grid2 item size={6}>
                                    <Switch checked={active} onChange={(e) => setActive(e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />
                                </Grid2>
                            </Grid2>
                        }

                        <Grid2 container spacing={12} sx={{ marginTop:'8%', marginBottom:'4%'}}>
                            <Grid2 item size={2.7}></Grid2>
                            <Grid2 item size={3} >
                                <Button variant="contained" sx={{width:'120px', textTransform:'none', boxShadow:'none', backgroundColor:'#0065ff', height:'42px'}} onClick={saveCategory}>Save</Button>
                            </Grid2>
                            <Grid2 item size={3} >
                                <Button onClick={handleClose} variant="contained" color="error"  sx={{width:'120px', textTransform:'none', boxShadow:'none', backgroundColor:'#D14545', height:'42px'}}>Cancel</Button>
                            </Grid2>
                            <Grid2 item size={3}></Grid2>
                        </Grid2>
                    </Grid2>
                </Box>
            </Modal>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
        </div>
    )
}

export default ChatSuggestion
